import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export const Columns = ({ children }) => (
  <div className={midas.columns}>{children}</div>
)

Columns.propTypes = {
  children: PropTypes.any.isRequired,
}
